// ======================================================================
// File Name       : AuthorityRegistUpdateConfirmDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import { MESSAGE_TYPE, MODAL_SIZE } from '../../constants/index';

const AboutAuthorityDialog = ({
  showModal,
  onAuthorityAboutOk,
}) => {
  const style = {
    background: 'none',
    width: 'auto',
    height: 'auto',
    marginLeft: 0,
    left: 0,
  };
  return (
    <Modal
      className="modal-container"
      show={showModal}
      onHide={onAuthorityAboutOk}
      size={MODAL_SIZE.lg}
      style={style}
      dialogClassName="about-authority-dialog"
    >
      <Modal.Header onHide={onAuthorityAboutOk} closeButton>
        <Modal.Title className="text-center">
          管理ユーザー画面の権限
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped hover>
          <thead>
            <tr>
              <th width={180} />
              <th>全て可能</th>
              <th>参照/採点のみ</th>
              <th>非表示</th>
            </tr>
          </thead>
          <tbody>
            <tr key="1">
              <td>
                ユーザー管理
              </td>
              <td>
                「ユーザー管理」が表示されます。<br />
                実施可能な機能は一覧情報の表示、詳細情報の表示、ユーザー追加、編集、削除、CSV一括投入となります。
              </td>
              <td>
                「ユーザー管理」が表示されます。<br />
                実施可能な機能は一覧情報の表示、詳細情報の表示となります。
              </td>
              <td>
                「ユーザー管理」が表示されません。
              </td>
            </tr>
            <tr key="2">
              <td>
                ユーザーグループ設定
              </td>
              <td>
                「ユーザーグループ設定」が表示されます。<br />
                実施可能な機能は一覧情報の表示、詳細情報の表示、ユーザーグループ追加、編集、削除、CSV一括投入となります。
              </td>
              <td>
                「ユーザーグループ設定」が表示されます。<br />
                実施可能な機能は一覧情報の表示、詳細情報の表示となります。
              </td>
              <td>
                「ユーザーグループ設定」が表示されません。
              </td>
            </tr>
            <tr key="3">
              <td>
                コース
              </td>
              <td>
                「コース」が表示されます。<br />
                実施可能な機能は、コース、セクション、コンテンツの一覧情報の表示、詳細情報の表示、追加、編集、削除、CSV一括追加となります。
              </td>
              <td>
                「コース」が表示されます。<br />
                実施可能な機能は、コース、セクション、コンテンツの一覧情報の表示、詳細情報の表示となります。

              </td>
              <td>
                「コース」が表示されません。
              </td>
            </tr>
            <tr key="4">
              <td>
                ビデオ/ドキュメント/リンク/ドリル
              </td>
              <td>
                「ビデオ」、「ドキュメント」、「リンク」、「ドリル」が表示されます。<br />
                実施可能な機能は、ビデオ、ドキュメント、リンク、ドリル、問題の一覧情報の表示、詳細情報の表示、追加、編集、削除、CSV一括追加となります。
              </td>
              <td>
                「ビデオ」、「ドキュメント」、「リンク」、「ドリル」が表示されます。<br />
                実施可能な機能は、ビデオ、ドキュメント、リンク、ドリル、問題の一覧情報の表示、詳細情報の表示となります。

              </td>
              <td>
                「ビデオ」、「ドキュメント」、「リンク」、「ドリル」が表示されません。
              </td>
            </tr>
            <tr key="5">
              <td>
                学習履歴
              </td>
              <td>
                -
              </td>
              <td>
                「学習履歴」が表示されます。<br />
                学習履歴の画面には「コース別」、「ユーザー別」、「コンテンツ別」のタブが表示され、コース軸、ユーザー軸、コンテンツ軸での履歴の閲覧が可能です。
              </td>
              <td>
                「学習履歴」が表示されません。
              </td>
            </tr>
            <tr key="6">
              <td>
                添削管理
              </td>
              <td>
                「添削管理」が表示されます。<br />
                添削管理の画面には「提出済みレポート一覧」、「未提出レポート一覧」、「レポート分配」、「添削者別実績一覧」のタブが表示され、実施可能な機能は一覧情報の表示、詳細情報の表示、添削、承認となります。
              </td>
              <td>
                「添削管理」が表示されます。<br />
                添削管理の画面には「提出済みレポート一覧」のみが表示され、実施可能な機能は一覧情報の表示、詳細情報の表示、添削となります。

              </td>
              <td>
                「添削管理」が表示されません。
              </td>
            </tr>
            <tr key="7">
              <td>
                メッセージ管理
              </td>
              <td>
                「メッセージ管理」が表示されます。 <br />
                メッセージに関するすべての機能が実施可能です。

              </td>
              <td>
                -
              </td>
              <td>
                「メッセージ管理」が表示されません。
              </td>
            </tr>
            <tr key="8">
              <td>
                お知らせ
              </td>
              <td>
                「お知らせ」が表示されます。<br />
                実施可能な機能は一覧情報の表示、詳細情報の表示、サービス向けお知らせの追加、編集、削除、CSV一括投入となります。

              </td>
              <td>
                「お知らせ」が表示されます。<br />
                実施可能な機能は一覧情報の表示、詳細情報の表示となります。

              </td>
              <td>
                「お知らせ」が表示されません。
              </td>
            </tr>
            <tr key="9">
              <td>
                メール連絡
              </td>
              <td>
                「メール連絡」が表示されます。<br />
                メールに関するすべての機能が実施可能です。
              </td>
              <td>
                -
              </td>
              <td>
                「メール連絡」が表示されません。
              </td>
            </tr>
            <tr key="10">
              <td>
                ライブ
              </td>
              <td>
                「ライブ」が表示されます。<br />
                ライブに関するすべての機能が実施可能です。
              </td>
              <td>
                -
              </td>
              <td>
                「ライブ」が表示されません。
              </td>
            </tr>
            <tr key="11">
              <td>
                受講ユーザー画面設定
              </td>
              <td>
                「受講ユーザー画面設定」が表示されます。<br />
                受講者画面設定に関するすべての機能が実施可能です。
              </td>
              <td>
                -
              </td>
              <td>
              「受講ユーザー画面設定」が表示されません。
              </td>
            </tr>
            <tr key="12">
              <td>
                システム利用実績管理
              </td>
              <td>
                -
              </td>
              <td>
                「システム利用実績管理」が表示されます。<br />
                システム利用実績管理の画面には「システム利用実績(サービス別)」が表示されます。
              </td>
              <td>
                「システム利用実績管理」が表示されません。
              </td>
            </tr>
            <tr key="13">
              <td>
                ロール設定
              </td>
              <td>
                「ロール設定」が表示されます。<br />
                実施可能な機能は一覧情報の表示、詳細情報の表示、ロール追加、編集、削除、CSV一括投入となります。
              </td>
              <td>
                「ロール設定」が表示されます。<br />
                実施可能な機能は一覧情報の表示、詳細情報の表示となります。
              </td>
              {/* Step10.0.0 START */}
              <td>
                「ロール設定」が表示されません。
              </td>
              {/* Step10.0.0 END */}
            </tr>
            <tr key="14">
              <td>
                TOP画面ダウンロードボタン
              </td>
              <td>
                ※ 「ダウンロード可」を選択 <br />
                TOP画面に「ダウンロード」ボタンが表示されます。<br />
                サンプルコンテンツ、サポートツールがダウンロードできます。
              </td>
              <td>
                -
              </td>
              <td>
                TOP画面に「ダウンロード」ボタンが表示されません。
              </td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer className="text-center">
        <Button variant="primary" className="margin-10 btn-96" onClick={onAuthorityAboutOk}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AboutAuthorityDialog;
